import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import type { TradeDetails, TradesResponse } from "../types";

export type TradeDirectionFilter = "all" | "long" | "short";
export type TradeStatusFilter = "all" | "open";

export interface TradesQuery {
  direction?: TradeDirectionFilter;
  status?: TradeStatusFilter;
  q?: string;
  botInstanceId?: string;
  page?: number;
  page_size?: number;
}

export function useTrades(query: TradesQuery) {
  return useQuery({
    queryKey: ["trades", query],
    queryFn: () =>
      api.get<TradesResponse>("/trades", {
        direction: query.direction ?? "all",
        status: query.status ?? "all",
        q: query.q || undefined,
        bot_instance_id: query.botInstanceId,
        page: query.page ?? 1,
        page_size: query.page_size ?? 50,
      }),
    placeholderData: (prev) => prev,
  });
}

export function useTradeDetails(tradeId: string | null) {
  return useQuery({
    queryKey: ["trade", tradeId],
    queryFn: () => api.get<TradeDetails>(`/trades/${encodeURIComponent(tradeId as string)}`),
    enabled: tradeId !== null,
  });
}
